import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Usuario } from '../../model/usuario';
import { Consorcio } from '../../model/consorcio';
import { Sucursal } from '../../model/sucursal';
import { UsuarioSucursal } from '../../model/usuario-sucursal';
import { ConsorciosService } from '../../services/consorcios.service';
import { UsuarioService } from '../../services/usuario.service';
import { SucursalService } from '../../services/sucursal.service';
import { UsuarioSucursalService } from '../../services/usuario-sucursal.service';


@Component({
  selector: 'app-usuario-mantenimiento',
  templateUrl: './usuario-mantenimiento.component.html',
  styleUrls: ['./usuario-mantenimiento.component.css']
})
export class UsuarioMantenimientoComponent implements OnInit {

  @Input() usuarioSeleccionada: Usuario;
  @Output() onReturn = new EventEmitter();

  public usuario: Usuario = new Usuario();
  public estadoBorrar: boolean = false;
  public estadoEditar: boolean = false;

  public usuarioSucursales = Array<UsuarioSucursal>();
  public usuarioSucursal: UsuarioSucursal = new UsuarioSucursal();
  public consorcios: Consorcio[];
  public consorcio: Consorcio;
  public sucursales: Sucursal[];
  public sucursal: Sucursal;
  public codigoSucursal: string;
  public tipousuario: string;
  public codigoConsorcio: string;
  public query: any;

  constructor(
    private _consorcioService: ConsorciosService,
    private _usuarioService: UsuarioService,
    private _sucursalService: SucursalService,
    private _usuarioSucursalService: UsuarioSucursalService
  ) { }


  ngOnInit() {
     if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }
    this.usuario = this.usuarioSeleccionada;
    this.tipousuario = this.usuario.tipo;
    if (this.usuario.codigoConsorcio != "NINGUNO") {
      this.codigoConsorcio = this.usuario.codigoConsorcio;
    }
    /*if (this.usuario.tipo === undefined) {
      this.tipousuario = "INT";
    }*/
    this.consorcio = null;
    this.usuarioSucursales = [];
    if (this.usuario.id == undefined) {

    } else {
      this.SeleccionarUsuarioSucursales();
    }
    if (this.usuario.id != null) {
      this.estadoEditar = true;
    }
    this.getConsorcios();
  }

  cargarSucursales() {
    if (this.codigoConsorcio === null) {
      return;
    }
    this.usuario.codigoConsorcio = this.codigoConsorcio;

    this.consorcio = new Consorcio();
    this.consorcio.codigoConsorcio = this.codigoConsorcio;
    this._sucursalService.getSucursales(this.consorcio)
      .subscribe(
      data => this.sucursales = data,
      err => {
        console.clear();
        console.log(err._body);
      });

  }

  agregarSucursal() {
    for (let i = 0; i < this.usuarioSucursales.length; i++) {
      if (this.usuarioSucursales[i].codigoSucursal === this.codigoSucursal) {
        alert("Sucursal ya ingresada");
        return
      }
    }
    this.usuarioSucursal = new UsuarioSucursal();
    this.usuarioSucursal.id = 0;
    this.usuarioSucursal.codigoConsorcio = this.consorcio.codigoConsorcio;
    this.usuarioSucursal.codigoSucursal = this.codigoSucursal;
    this.usuarioSucursal.email = this.usuario.email;

    this._usuarioSucursalService.insert(this.usuarioSucursal).subscribe(
      result => this.SeleccionarUsuarioSucursales(),
      err => {
        console.clear();
        console.log(err._body);
      });
  }


  getConsorcios() {
    this.query = { "email": sessionStorage.getItem("login") };

    this._consorcioService.getConsorciosUsuario(this.query)
      .subscribe(
      data => { this.consorcios = data; },
      err => {
        console.log(err);
      });
  }

  eliminar_Permiso(usuario_eliminar: UsuarioSucursal) {
    //  console.log(this.usuarioSucursales.length);
    for (let i = 0; i < this.usuarioSucursales.length; i++) {
      if (this.usuarioSucursales[i].codigoSucursal === usuario_eliminar.codigoSucursal) {
        this.usuarioSucursales.splice(i, 1);
        this._usuarioSucursalService.delete(usuario_eliminar).subscribe(
          result => this.SeleccionarUsuarioSucursales(),
          err => {
            console.clear();
            console.log(err._body);
          });
        // delete this.usuarioSucursales[i];
        //  console.log(this.usuarioSucursales.length);
        return
      }
    }
  }
  changeType(tipo: string) {
    //  this.tipousuario="EXT_SUC";
    if (this.usuario.tipo === "EXT_SUC") {
      if (this.usuarioSucursales.length === 0 || this.usuarioSucursales.length === undefined) {
        this.usuario.tipo = tipo;
        return;
      }
      if (this.usuario.tipo != tipo) {
        alert("existen sucursales asociadas a este usuario");
        this.tipousuario = this.usuario.tipo;
      }
      //this.tipousuario=this.usuario.tipo;
    }
  }

  SeleccionarUsuarioSucursales() {
    this._usuarioSucursalService.findUsuarioSucursal(this.usuario)
      .subscribe(
      data => {
        // console.log(data);
        this.usuarioSucursales = data
      },
      err => {
        console.clear();
        console.log(err._body);
      });
  }

  onSubmitSuccess(data: any) {
    this.regresar();
  }

  onSubmit() {
    this.usuario.tipo = this.tipousuario;
    if (this.usuario.id === undefined) {
      this.usuario.id = 0;
    }
    if (this.usuario.tipo === "INT") {
      this.usuario.codigoConsorcio = "NINGUNO";
    }
    this._usuarioService.insert(this.usuario).subscribe(
      result => this.onSubmitSuccess(result),
      err => {
        console.clear();
        console.log(err._body);
      });

    /* this._sucursalService.insert(this.sucursal).subscribe(
            result => this.onSubmitSuccess(result),
            err=> {
              console.clear();
              console.log(err._body);
            }) ;    */
  }

  /* Navegación */

  regresar() {
    this.onReturn.emit();
  }

  solicitaBorrar() {
    this.estadoBorrar = true;
  }
  
  solicitudBorrarCancelar() {
    this.estadoBorrar = false;
  }

  borrarRegistro() {
    if (this.usuario.tipo === "EXT_SUC") {
      if (this.usuarioSucursales.length === 0 || this.usuarioSucursales.length === undefined) {
        this._usuarioService.delete(this.usuario).subscribe(
          result => this.regresar(),
          err => {
            console.clear();
            console.log(err._body);
          });
        return;
      } else {
        alert("existen sucursales asociadas a este usuario, es necesario no tener ninguno asociado.");
        return;
      }
    }
    else {
      this._usuarioService.delete(this.usuario).subscribe(
        result => this.regresar(),
        err => {
          console.clear();
          console.log(err._body);
        });
      return;
    }
  }


}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/usuario-mantenimiento/usuario-mantenimiento.component.ts